import React from 'react'
import BgPattern from './BgPattern'

const LoadingOverlay = () => {
  return (
    <div className="loading-overlay">
      <BgPattern/>
      <div className="container">
        {/* <h1>Loading...</h1> */}
        <img src="/assets/images/altavie-logo.svg" alt="AltaVie"/>
      </div>
    </div>
  )
}

export default LoadingOverlay


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.js